import { type ResponseConfig } from "@kubb/swagger-client/client"
import { notifications } from "@mantine/notifications"
import { UseMutationOptions } from "@tanstack/react-query"

import { queryClient } from "~/backend/queryClient"
import {
  findMappingByTypeQueryKey,
  findPendingMappingQueryKey,
  useDeleteMappingElement,
} from "~/gen/api/hooks"
import { DeleteMappingElementRequestDto } from "~/gen/api/types"

export const useDeleteMappingElementMutation = (
  options?: UseMutationOptions<
    ResponseConfig<boolean>,
    unknown,
    DeleteMappingElementRequestDto
  >
) =>
  useDeleteMappingElement({
    mutation: {
      ...options,
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries(
          findMappingByTypeQueryKey(variables.type)
        )
        await queryClient.invalidateQueries(findPendingMappingQueryKey())
        notifications.show({
          title: "Deleted",
          message: ` mapping has been deleted`,
          color: "green",
        })
      },
    },
  })
